import { ViteSSG } from 'vite-ssg';
import { RouteLocation } from 'vue-router';

import UktApp from './components/UktApp.vue';
import UktIndexPage from './components/pages/UktIndexPage.vue';
import UktEventsPage from './components/pages/UktEventsPage.vue';

import { DISCORD_INVITE } from "./constants";

export const createApp = ViteSSG(UktApp, {
  routes: [
    {
      path: '/',
      name: 'IndexPage',
      component: UktIndexPage
    },
    {
      path: '/events',
      name: 'EventsPage',
      component: UktEventsPage
    },

    // REDIRECTS

    // Remove .html or .htm at the end
    {
      path: '/:pathMatch(.*)*:ext(\\.html?)',
      redirect: (to: RouteLocation) => {
        return { path: `/${to.params.pathMatch}` };
      }
    },
    // Redirect any unknown route to the index page
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
}, ({ app }) => {

  // DIRECTIVES

  app.directive('discordInvite', {
    mounted(el: HostElement) {
      el.href = DISCORD_INVITE;
      el.target = '_blank';
    }
  });

});
